<script lang="ts">
  export let size = 18;
</script>

<svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M4.05 1.57495H13.95C14.775 1.57495 15.45 2.24995 15.45 3.07495V4.72495C15.45 5.32495 15.075 6.07495 14.7 6.44995L11.475 9.29995C11.025 9.67495 10.725 10.425 10.725 11.025V14.25C10.725 14.7 10.425 15.3 10.05 15.525L9 16.2C8.025 16.8 6.675 16.125 6.675 14.925V10.95C6.675 10.425 6.375 9.74995 6.075 9.37495L3.225 6.37495C2.85 5.99995 2.55 5.32495 2.55 4.87495V3.14995C2.55 2.24995 3.225 1.57495 4.05 1.57495Z"
    class={$$props.class || "stroke-current"}
    stroke-width="1.5"
    stroke-miterlimit="10"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M8.1975 1.57495L4.5 7.49995"
    class={$$props.class || "stroke-current"}
    stroke-width="1.5"
    stroke-miterlimit="10"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <!-- <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
	<g id="vuesax/linear/filter">
		<g id="filter">
			<path
				id="Vector"
				d="M4.04999 1.5752H13.95C14.775 1.5752 15.45 2.2502 15.45 3.0752V4.7252C15.45 5.3252 15.075 6.0752 14.7 6.4502L11.475 9.30019C11.025 9.67519 10.725 10.4252 10.725 11.0252V14.2502C10.725 14.7002 10.425 15.3002 10.05 15.5252L8.99999 16.2002C8.02499 16.8002 6.67499 16.1252 6.67499 14.9252V10.9502C6.67499 10.4252 6.37499 9.7502 6.07499 9.3752L3.22499 6.3752C2.84999 6.0002 2.54999 5.3252 2.54999 4.8752V3.1502C2.54999 2.2502 3.22499 1.5752 4.04999 1.5752Z"
				stroke="#47675B"
				stroke-width="1.5"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				id="Vector_2"
				d="M8.1975 1.5752L4.5 7.5002"
				stroke="#47675B"
				stroke-width="1.5"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</g>
	</g> -->
</svg>
